import React from 'react';

export const ForgotPasswordLock = () => {
  return (
    <svg width="52" height="62" viewBox="0 0 52 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.2645 34.8553H39.2206V18.2055C39.2206 10.9458 33.2832 5.03891 26.0001 5.03891C18.7169 5.03891 12.7795 10.9458 12.7795 18.2055V34.8553H7.7356V18.2055C7.7356 8.17273 15.9235 0 26.0001 0C36.0766 0 44.2645 8.17273 44.2645 18.2055V34.8553Z"
        fill="#828282"
      />
      <path
        d="M52 60.0499C52 61.1208 51.1179 62 50.0435 62H1.9565C0.882121 62 0 61.1208 0 60.0499V28.9033C0 27.8324 0.882121 26.9531 1.9565 26.9531H50.0435C51.1179 26.9531 52 27.8324 52 28.9033V60.0499Z"
        fill="url(#paint0_linear_15612_29526)"
      />
      <path
        d="M51.9998 60.0498V40.9651C36.1556 54.3233 13.3222 59.3509 0.373047 61.1884C0.734943 61.6731 1.30041 62 1.95634 62H50.0433C51.1177 62 51.9998 61.1207 51.9998 60.0498Z"
        fill="#EAB531"
      />
      <path
        d="M30.2974 39.1952C30.2974 36.8392 28.3749 34.9229 25.9999 34.9229C23.625 34.9229 21.7024 36.8392 21.7024 39.1952C21.7024 40.6156 22.3923 41.8556 23.444 42.6334L22.0756 52.3279H29.9242L28.5558 42.6334C29.6076 41.8556 30.2974 40.6156 30.2974 39.1952Z"
        fill="#2C2C2C"
      />
      <path
        d="M1.63989 30.6506V37.3579C1.82084 34.5059 3.18926 28.3059 11.7956 28.3059H3.98091C2.69165 28.3059 1.63989 29.3656 1.63989 30.6506Z"
        fill="#F7DB5E"
      />
      <path d="M22.0757 52.3281C22.0757 52.3281 27.9 50.6823 28.5559 42.6335L29.9243 52.3281H22.0757Z" fill="#323232" />
      <defs>
        <linearGradient
          id="paint0_linear_15612_29526"
          x1="0.541666"
          y1="61.635"
          x2="32.6886"
          y2="13.9377"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBF17" />
          <stop offset="1" stopColor="#F2E2B8" />
        </linearGradient>
      </defs>
    </svg>
  );
};
